/* section-reload.js — KOSHO SG Shopify theme-editor lifecycle dispatcher.
 * ----------------------------------------------------------------------------
 * Re-initialises scope-aware components when the theme editor reloads a single
 * section, and tears down stateful components (notably slider autoplay timers)
 * when a section is removed. This file is INERT on the live storefront:
 * Shopify only fires the `shopify:section:*` / `shopify:block:*` events while
 * Shopify.designMode is true (i.e. inside the theme editor). It exists purely
 * to keep the editor preview correct and to prevent interval / timer leaks
 * caused by repeated mount without teardown.
 *
 * Scope-aware re-init (each guarded by a typeof check + try/catch):
 *   window.KoshoSlider     .mountAll(scope)
 *   window.KoshoAccordion  .mountAll(scope)
 *   window.KoshoQtyStepper .mountAll(scope)
 *   window.KoshoGallery    .mountAll(scope)
 *   window.KoshoNewsletter .init(scope)
 *   window.KoshoHeader     .init(scope)   (only when the section contains the header)
 *
 * Excluded by design (NOT re-initialised here): mobile-nav, search-overlay,
 * cart, age-gate, cookie-banner — these bind document-level delegated
 * listeners once and would double-bind if re-initialised per section.
 * ------------------------------------------------------------------------- */

(function (window, document) {
  'use strict';

  /* ------------------------------------------------------------------------
   * shopify:section:load — a section was added or reloaded in the editor.
   * e.target is the section's root DOM element; scope re-init to it.
   * ------------------------------------------------------------------------ */
  function onSectionLoad(e) {
    var t = e.target;
    if (!t) return;

    try {
      if (window.KoshoSlider && typeof KoshoSlider.mountAll === 'function') {
        KoshoSlider.mountAll(t);
      }
    } catch (err) {}

    try {
      if (window.KoshoAccordion && typeof KoshoAccordion.mountAll === 'function') {
        KoshoAccordion.mountAll(t);
      }
    } catch (err) {}

    try {
      if (window.KoshoQtyStepper && typeof KoshoQtyStepper.mountAll === 'function') {
        KoshoQtyStepper.mountAll(t);
      }
    } catch (err) {}

    try {
      if (window.KoshoGallery && typeof KoshoGallery.mountAll === 'function') {
        KoshoGallery.mountAll(t);
      }
    } catch (err) {}

    try {
      if (window.KoshoNewsletter && typeof KoshoNewsletter.init === 'function') {
        KoshoNewsletter.init(t);
      }
    } catch (err) {}

    try {
      if (t.querySelector && t.querySelector('[data-component="header"]')) {
        if (window.KoshoHeader && typeof KoshoHeader.init === 'function') {
          KoshoHeader.init(t);
        }
      }
    } catch (err) {}
  }

  /* ------------------------------------------------------------------------
   * shopify:section:unload — a section was removed in the editor.
   * Tear down any stateful instances under it so their timers / intervals do
   * not leak. This is the core autoplay-interval guard for the slider.
   * ------------------------------------------------------------------------ */
  function onSectionUnload(e) {
    var t = e.target;
    if (!t) return;

    try {
      var sliders = t.querySelectorAll('[data-slider]');
      Array.prototype.forEach.call(sliders, function (el) {
        if (el.__koshoSlider && typeof el.__koshoSlider.destroy === 'function') {
          try { el.__koshoSlider.destroy(); } catch (err) {}
        }
      });
    } catch (err) {}

    try {
      var galleries = t.querySelectorAll('[data-product-gallery]');
      Array.prototype.forEach.call(galleries, function (el) {
        if (el.__koshoGallery && typeof el.__koshoGallery.closeLightbox === 'function') {
          try { el.__koshoGallery.closeLightbox(); } catch (err) {}
        }
      });
    } catch (err) {}
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);

})(window, document);
